import { getEmailColumn } from 'constants/getExcelColumns';
import checkIsValidEmail from 'utils/checkIsValidEmail';

const getInvalidEmails = (partners: any): any => {
  const result = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const partner of partners) {
    const email = getEmailColumn(partner);

    if (!email) {
      // Empty emails are allowed — generateEmail() will assign one on upload
      // eslint-disable-next-line no-continue
      continue;
    }

    const validEmail = checkIsValidEmail(email);
    if (!validEmail) {
      result.push(email);
    }
  }
  return result;
};

export default getInvalidEmails;
